import type { Api } from "../../data/api";
import { buildKitView, kitOutcomeFromError, kitOutcomeFromResponse, kitTokenLooksValid, type KitOutcome, type KitView } from "./kit-model";

/**
 * Media-Kit-Link öffnen (0074). media_kit_open schreibt (Aufruf bzw. Fehlversuch) und läuft deshalb nur auf ausdrückliche
 * Eingabe, als anonyme Person, nie in einer Abfrage, die sich neu lädt.
 */
/**
 * 0425: Gehört der Link einer Agentur, deren Vertrag beendet ist? Dann zeigt die Seite sofort „nicht mehr verfügbar“, ohne vorher
 * die Mailadresse abzufragen. public_link_ended schreibt nichts und liefert keine Daten (nur ja/nein); bei Fehlern nein.
 */
export async function linkBeendet(api: Pick<Api, "rpcAsAnon">, kind: "kit" | "share", token: string): Promise<boolean> {
  try {
    return (await api.rpcAsAnon<boolean>("public_link_ended", { p_kind: kind, p_token: token })) === true;
  } catch {
    return false;
  }
}

export async function openKit(api: Pick<Api, "rpcAsAnon">, token: string, email: string): Promise<KitOutcome> {
  if (!kitTokenLooksValid(token)) return { kind: "invalid" };
  try {
    return kitOutcomeFromResponse(await api.rpcAsAnon<unknown>("media_kit_open", { p_token: token, p_email: email.trim().toLowerCase() }));
  } catch (e) {
    return kitOutcomeFromError(e);
  }
}

export type KitTeamOutcome =
  | { kind: "team"; view: KitView; locked: boolean; recipient: string | null }
  | { kind: "revoked" }
  | { kind: "expired" }
  | { kind: "none" };

/** Angemeldetes Team der Agentur sieht den Link wie die Marke, ohne Mail-Prüfung und ohne Protokolleintrag (liest nur). */
export async function openKitAsTeam(api: Pick<Api, "read">, token: string): Promise<KitTeamOutcome> {
  if (!kitTokenLooksValid(token)) return { kind: "none" };
  try {
    const r = await api.read<unknown>("media_kit_open_team", { p_token: token });
    const o = (typeof r === "string" ? JSON.parse(r) : r) as Record<string, unknown> | null;
    const view = buildKitView(o);
    if (!o || !view) return { kind: "none" };
    return { kind: "team", view, locked: o.locked === true, recipient: typeof o.recipient === "string" ? o.recipient : null };
  } catch (e) {
    const out = kitOutcomeFromError(e);
    return out.kind === "revoked" || out.kind === "expired" ? out : { kind: "none" };
  }
}
